module.exports = __webpack_public_path__ + "media/images/admin/icons/circle-aeb8a72427916fe8cb227e59a33a31e8.svg";